export default "__VITE_ASSET__KBrpRC7s__"